import React from 'react'
import styled, { css, withTheme } from 'styled-components'
import Spacer from '../../../lib/spacer'
import { large, medium } from '../../../lib/media_query'
import dashboardAbstract from '../../../img/dashboard-screenshot-dark.webp'
import Card from './card'
import Notification from './notification'
import { bob } from '../../../lib/animations'
import BulletPoint from '../../../common/bullet_point'
import { FaRegWindowMaximize, FaRegBell, FaRegLightbulb } from 'react-icons/fa'
import { useTranslation } from '../../../lib/i18n'

const Wrapper = styled.div``

const ImageBob = styled.div`
    animation-name: ${bob};
    animation-duration: 2.6s;
    animation-delay: ${({ delayIndex }) => delayIndex * 300}ms;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    animation-direction: alternate;
`
const DashboardImageWrapper = styled.div`
    position: relative;

    ${medium(css`
        width: 360px;
    `)}
    ${large(css`
        width: 390px;
    `)}

    .dashboard-abstract {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    .wheels-next-break {
        position: absolute;
        top: -55px;
        left: 33%;

        img {
            transform: scale(0.8);
        }
    }

    .notification-abstract {
        position: absolute;
        left: -70px;
        top: 45%;
    }

    .wheels-resting {
        position: absolute;
        left: 50%;
        bottom: -82px;

        img {
            transform: scale(0.8);
        }
    }
`

export const Dashboard = ({ theme }) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'home.dashboard' })

    return (
        <Wrapper>
            <div className="grid-x align-center">
                <div className="cell large-5 medium-10 medium-order-1">
                    <div className="grid-y">
                        <BulletPoint icon={FaRegWindowMaximize} className="cell medium-4">
                            <h4>{t('menuBar.title')}</h4>
                            <p>{t('menuBar.body')}</p>
                        </BulletPoint>
                        <BulletPoint icon={FaRegBell} className="cell medium-4">
                            <h4>{t('reminds.title')}</h4>
                            <p>{t('reminds.body')}</p>
                        </BulletPoint>
                        <BulletPoint icon={FaRegLightbulb} className="cell medium-4">
                            <h4>{t('whenNeeded.title')}</h4>
                            <p>{t('whenNeeded.body')}</p>
                        </BulletPoint>
                    </div>
                </div>
                <div className="cell large-7 medium-12">
                    <div className="max-height">
                        <Spacer className="show-for-small-only" size={50} />
                        <div className="grid-x small-align-center align-middle max-height">
                            <div className="cell medium-shrink small-11">
                                <DashboardImageWrapper>
                                    <img
                                        className="dashboard-abstract"
                                        src={dashboardAbstract}
                                        alt={t('imageAlt')}
                                    />
                                    <ImageBob delayIndex={0} className="wheels-next-break">
                                        <Card
                                            title={t('nextBreak.title')}
                                            value={3}
                                            label={t('nextBreak.label')}
                                            wheelProps={{
                                                strokeColor: theme.palette.greyScale.altGrey,
                                                progress: 0.8
                                            }}
                                        />
                                    </ImageBob>
                                    <ImageBob
                                        delayIndex={3}
                                        className="notification-abstract  hide-for-small-only"
                                    >
                                        <Notification />
                                    </ImageBob>
                                    <ImageBob delayIndex={2} className="wheels-resting">
                                        <Card
                                            title={t('keypresses.title')}
                                            label={t('keypresses.label')}
                                            wheelProps={{
                                                strokeColor: theme.palette.greyScale.altGrey,
                                                progress: 0.6
                                            }}
                                        />
                                    </ImageBob>
                                </DashboardImageWrapper>
                            </div>
                        </div>
                        <Spacer className="show-for-medium-only" size={240} />
                        <Spacer className="show-for-small-only" size={120} />
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export default withTheme(Dashboard)
